import { useParams } from 'react-router';

export const useIsSite = (): boolean => {
  const { customerId } = useParams();

  return customerId !== undefined;
};
